import { render, staticRenderFns } from "./admin-manage.vue?vue&type=template&id=1b31ae0a&scoped=true"
import script from "./admin-manage.vue?vue&type=script&lang=js"
export * from "./admin-manage.vue?vue&type=script&lang=js"
import style0 from "./admin-manage.vue?vue&type=style&index=0&id=1b31ae0a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b31ae0a",
  null
  
)

export default component.exports